import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { ALERTS, FormBuilder, FormGroup, Router, Validators } from 'src/app/common';
import { IPermission } from 'src/app/models';
import { AlertService, AuthenticationService, SideBarService, StorageService } from 'src/app/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  isLogin: boolean;
  loading = false;
  perms: IPermission[];
  
  constructor(private fb: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private alertService: AlertService,
    private storageService: StorageService, 
    private sidebarService: SideBarService
  ) {
    if (this.auth.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.initializePage();
  }

  initializePage() {
    this.isLogin = true;

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]],
      password: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get fLogin() { return this.loginForm.controls; }

  // funcion para el envio del formulario, tanto de login como de signin
  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.auth.login(this.fLogin.email.value, this.fLogin.password.value)
      .pipe(first())
      .subscribe(data => {
        this.loading = false;
        this.GetUserRole('');
        this.sidebarService.toggler.next(true);
        this.router.navigateByUrl('home');
      }, error => {
        this.loading = false;
        this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
      });
  }

  /*
  * Funcion para cambiar entre el formulario de login y de sigin
  */
  clickEvent(islogin: boolean) {
    this.isLogin = islogin;
    // se activa el form de login
    if (this.isLogin) {
      this.loginForm = this.fb.group({
        email: ['', [Validators.required, Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
        password: ['', Validators.required]
      });
      // se activa el form de recuperar la contrasenna
    } else {
      this.loginForm = this.fb.group({
        email: ['', [Validators.required, Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]]
      });
    }
  }

  GetUserRole(_userId: string): void {
  }

  getUserGeoConfigs() {
    let geoConfigs: any[] = [];
  }

}

